let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g9bbN")).then(() => parcelRequire('6EvpZ'));